import React from "react";
import { Alert } from "@mui/material";
import Header from "../components/Header";

const AboutPage = () => (
  <>
    <Header>
      <h1>Refurbishment</h1>
    </Header>
    <Alert severity="info">Coming Soon!</Alert>
  </>
);

export default AboutPage;
